/**
 * @generated SignedSource<<ccb1c08eeb16ac604eba2cf8d3b3da29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EndMeetingMutation$variables = {
  noteId: string;
};
export type EndMeetingMutation$data = {
  readonly noteEndMeeting: {
    readonly note: {
      readonly finished: boolean;
      readonly finishedAt: string | null;
    };
  } | null;
};
export type EndMeetingMutation = {
  response: EndMeetingMutation$data;
  variables: EndMeetingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finished",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finishedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EndMeetingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteEndMeeting",
        "kind": "LinkedField",
        "name": "noteEndMeeting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EndMeetingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteEndMeeting",
        "kind": "LinkedField",
        "name": "noteEndMeeting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6849c27b159ebe5f9b8c3f8eae1cecbb",
    "id": null,
    "metadata": {},
    "name": "EndMeetingMutation",
    "operationKind": "mutation",
    "text": "mutation EndMeetingMutation(\n  $noteId: ID!\n) {\n  noteEndMeeting(noteId: $noteId) {\n    note {\n      finished\n      finishedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "21d0416b69bd5f95be3c2a9d9ea4eac2";

export default node;
